import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { MainNavButton } from '../nav-button';

const COPY = defineMessages({
  DATA_STUDIO: {
    id: 'DataStudio.dataStudio',
    defaultMessage: 'Data Studio BETA',
    description: '[Type: Label][Vis.: low] - Data Studio section of nav bar',
  },
});

const DataStudio = () => (
  <MainNavButton
    href="/workspaces/"
    label={t(COPY.DATA_STUDIO)}
    navItem="data studio"
  />
);

export default DataStudio;
export { DataStudio };
